export const expandToFillContainerStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
};
const containerMatchContentDimensionsStyle = {
    display: 'inline-block',
};
export const containerSizingStyles = containerMatchContentDimensionsStyle;
export const pausedOverlayWrapperSizingStyles = expandToFillContainerStyle;
export const videoSizingStyles = {
    display: 'block',
    width: '100%',
};
